@if (!hasGeometries) {
  <div class="map-empty" data-testid="map-empty">
    <span class="map-empty__text">No mapped features for this form.</span>
  </div>
} @else {
  <div class="map-host" data-testid="map-host">
    <app-sites-location-map
      class="map-content"
      [isSingleDayMode]="true"
      [viewBy]="'bid_item'"
      [showEmbeddedControls]="true"
      [selectedBidItemIds]="selectedBidItemIds"
      [bidItemsWithGeometries]="bidItemsWithGeometries"
      [hoveredBidItemId]="hoveredBidItemId"
    ></app-sites-location-map>

    @if (bidItems.length > 0) {
      <div class="bid-item-panel" data-testid="map-bid-item-panel">
        <div class="bid-item-panel__header">{{ bidItems.length }} bid items</div>
        <div class="bid-item-panel__list">
          @for (bidItem of bidItems; track bidItem.bid_item_id) {
            <div
              class="bid-item-row"
              data-testid="map-bid-item-row"
              [matTooltip]="bidItem.item + ' - ' + bidItem.description"
              matTooltipPosition="left"
              matTooltipClass="project-name-tooltip"
              (mouseenter)="onBidItemRowEnter(bidItem.bid_item_id)"
              (mouseleave)="onBidItemRowLeave()"
            >
              <span class="bid-item-row__swatch" [style.background-color]="bidItem.color"></span>
              <span class="bid-item-row__label">{{ bidItem.item }} - {{ bidItem.description }}</span>
            </div>
          }
        </div>
      </div>
    }
  </div>
}
